import React, { useMemo, useState } from 'react';
import { RepeatIcon } from 'lucide-react';
import { PageHeader } from '../components/layout/PageHeader';
import { FAB } from '../components/ui/FAB';
import { EmptyState } from '../components/ui/EmptyState';
import { HabitCard } from '../components/habits/HabitCard';
import { AddHabitSheet } from '../components/habits/AddHabitSheet';
import { useAppData } from '../contexts/AppDataContext';
import { getStreak } from '../utils/habits';
import { getTodayKey } from '../utils/date';
export function Habits() {
  const {
    habits,
    addHabit,
    toggleHabitToday,
    deleteHabit
  } = useAppData();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const todayKey = getTodayKey();
  const completedCount = useMemo(() => habits.filter(h => h.completions.includes(todayKey)).length, [habits, todayKey]);
  return <div className="relative flex h-full flex-col" data-id="element-168" data-mp="2zv4gfh6jr4c">
      <PageHeader title="Habits" subtitle={habits.length ? `${completedCount} of ${habits.length} done today` : 'Build a routine that sticks'} data-id="element-169" data-mp="7ypyyeoif44a" />
      <div className="flex-1 space-y-3 overflow-y-auto px-5 py-4 pb-28" data-id="element-170" data-mp="1351j7oaexs09">
        {habits.length === 0 ? <EmptyState icon={RepeatIcon} title="No habits yet" description="Add one to start building your routine." data-id="element-171" data-mp="uawx1i6854r2" /> : habits.map(habit => <HabitCard key={habit.id} habit={habit} streak={getStreak(habit)} onToggleToday={() => toggleHabitToday(habit.id)} onDelete={() => deleteHabit(habit.id)} data-id="element-172" data-mp="pbk2eb942tdx" />)}
      </div>
      <FAB label="Add habit" onClick={() => setIsAddOpen(true)} colorClassName="bg-teal-600 hover:bg-teal-700" data-id="element-173" data-mp="bcu62xu48xqm" />
      <AddHabitSheet isOpen={isAddOpen} onClose={() => setIsAddOpen(false)} onSubmit={addHabit} data-id="element-174" data-mp="6eslg8h1kqd1" />
    </div>;
}